// These programIDs are absorbed by Hubspot Forms across our site
// in order to map user's form submission to sales campaigns

const ProgramIDs = Object.freeze({
  GeneralIntegrations: '7014V000001yzq9QAA',
  ZoomIntegration: '7014V000002YsROQA0',
  HIPAAIntegration: '7014V000002XmJRQA0',
  SMSCollector: '7014V000002MgaCQAS',
  SingleSignOn: '7014V000002hM6XQAU',
  ProfessionalServices: '7014V000002dEzdQAE',
  Marketing: '7014V000002pf9LQAQ',
  ContactSalesPNP: '701PZ000008DyhiYAC',
});

export default ProgramIDs;
